var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctagonExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.8 157.1l-127.1-127.9C346.4 20.8 334.1 16 323 16H188.9c-11.84 0-23.32 4.805-31.76 13.24L29.24 157.2C20.8 165.6 16 177 16 188.1v134.2c0 11.84 4.805 23.32 13.24 31.76l127.1 127.9C165.6 491.2 177 496 188.1 496h134.2c11.84 0 23.32-4.805 31.76-13.24l127.9-127.1C491.2 346.4 496 334.1 496 323V188.9C496 177 491.2 165.5 482.8 157.1zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonExclamation);
export default __webpack_public_path__ + "static/media/octagon-exclamation.0df7da60807d9bf5a6430fe115d65557.svg";
export { ForwardRef as ReactComponent };